export const RegexPatterns = {
  ssn: '\\d{3}-?\\d{2}-?\\d{4}',
  visa: '\\d{9}',
  uscis: '^[a-zA-Z0-9]{7,9}$',
  website: '(http://www.|https://www.|http://|https://)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9]+)*.[a-zA-Z]{2,5}(:[0-9]{1,5})?(/.*)?',
  password: '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\\d!@#$%^&*]{8,}',
  decimal2: '\\d+\\.?\\d{0,2}',
  wholeNumber: '\\d+',
};
